(() => {
  class AteaseSpecializedTrack extends HTMLElement {
    connectedCallback(){ if(this.ready)return; this.ready=true; this.viewport=this.querySelector('[data-atease-track-viewport]'); this.items=[...(this.viewport?.children||[])]; this.prev=this.querySelector('[data-atease-track-previous]'); this.next=this.querySelector('[data-atease-track-next]'); this.status=this.querySelector('[data-atease-track-status]'); this.prev?.addEventListener('click',()=>this.move(-1)); this.next?.addEventListener('click',()=>this.move(1)); this.viewport?.addEventListener('scroll',()=>this.update(),{passive:true}); this.update(); }
    move(direction){ const item=this.items[this.index()+direction]; if(item)this.viewport.scrollTo({left:item.offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}); }
    index(){ if(!this.viewport)return 0; return this.items.reduce((best,item,i)=>Math.abs(item.offsetLeft-this.viewport.scrollLeft)<Math.abs(this.items[best].offsetLeft-this.viewport.scrollLeft)?i:best,0); }
    update(){ const i=this.index(); if(this.prev)this.prev.disabled=i<=0; if(this.next)this.next.disabled=i>=this.items.length-1; if(this.status)this.status.textContent=`${Math.min(i+1,this.items.length)} / ${this.items.length}`; }
  }
  if(!customElements.get('atease-track')) customElements.define('atease-track',AteaseSpecializedTrack);
  class AteaseSpecializedHomes extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelectorAll('[data-atease-home-card]').forEach(card => {
        const video = card.querySelector('video');
        const play = card.querySelector('[data-atease-home-play]');
        const mute = card.querySelector('[data-atease-home-mute]');
        const playText = play.querySelector('[data-atease-control-label]');
        const muteText = mute.querySelector('[data-atease-control-label]');
        if (!video || !play || !mute) return;
        const sync = () => {
          const playing = !video.paused && !video.ended;
          card.toggleAttribute('data-playing', playing);
          card.toggleAttribute('data-muted', video.muted);
          play.setAttribute('aria-pressed', String(playing));
          mute.setAttribute('aria-pressed', String(video.muted));
          const playLabel = playing ? play.dataset.pauseLabel : play.dataset.playLabel;
          const muteLabel = video.muted ? mute.dataset.unmuteLabel : mute.dataset.muteLabel;
          play.setAttribute('aria-label', playLabel);
          play.title = playLabel;
          mute.setAttribute('aria-label', muteLabel);
          mute.title = muteLabel;
          playText.textContent = playing ? play.dataset.pauseShortLabel : play.dataset.playShortLabel;
          muteText.textContent = video.muted ? mute.dataset.soundOnShortLabel : mute.dataset.soundOffShortLabel;
        };
        play.addEventListener('click', () => {
          if (video.paused) video.play().catch(() => { video.controls = true; sync(); });
          else video.pause();
        }, options);
        mute.addEventListener('click', () => { video.muted = !video.muted; }, options);
        video.addEventListener('play', () => {
          this.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
          sync();
        }, options);
        ['pause', 'ended', 'volumechange'].forEach(event => video.addEventListener(event, sync, options));
        video.controls = false;
        card.setAttribute('data-atease-home-controls-ready', '');
        sync();
      });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.querySelectorAll('video').forEach(video => {
        video.pause();
        video.controls = true;
        video.closest('[data-atease-home-card]')?.removeAttribute('data-atease-home-controls-ready');
      });
    }
  }
  if(!customElements.get('atease-homes')) customElements.define('atease-homes',AteaseSpecializedHomes);

  class AteaseDeliveryRoutes extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.toggle = this.querySelector('[data-atease-delivery-routes-toggle]');
      this.label = this.toggle?.querySelector('span');
      this.routes = this.querySelector('[data-atease-delivery-routes-list]');
      if (!this.toggle || !this.label || !this.routes) return;
      if (!this.routes.id.trim() || this.routes.id !== this.toggle.getAttribute('aria-controls')) return;
      this.ready = true;

      this.toggle.addEventListener('click', () => {
        this.setExpanded(this.toggle.getAttribute('aria-expanded') !== 'true');
      });
      this.setExpanded(false);
      this.setAttribute('data-atease-delivery-routes-ready', '');
    }

    setExpanded(expanded) {
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.label.textContent = expanded ? this.toggle.dataset.collapseLabel : this.toggle.dataset.expandLabel;
    }
  }

  if (!customElements.get('atease-delivery-routes')) customElements.define('atease-delivery-routes', AteaseDeliveryRoutes);

  const body = document.body;
  if (!body?.classList.contains('template-index') || body.hasAttribute('data-atease-utilities-ready')) return;
  body.setAttribute('data-atease-utilities-ready', '');
  const mobileUtilities = matchMedia('(max-width: 767px)');
  const scrollLimit = () => Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  const scrollPosition = () => Math.max(0, Math.min(window.scrollY, scrollLimit()));
  let lastY = scrollPosition();
  let direction = 0;
  let distance = 0;
  let pending = false;

  const chatRoots = () => {
    const roots = [];
    const visit = root => {
      if (!root) return;
      roots.push(root);
      root.querySelectorAll('[exportparts]').forEach(element => visit(element.shadowRoot));
    };
    visit(document.querySelector('shopify-chat')?.shadowRoot);
    return roots;
  };
  const updateChatClearance = () => {
    let obstructing = false;
    if (mobileUtilities.matches) {
      // Read only the publicly exposed activator part; Inbox owns its DOM/actions.
      const activator = chatRoots().map(root => root.querySelector('[part~="activator"]')).find(Boolean);
      const box = activator?.getBoundingClientRect();
      if (box?.width && box.height) {
        const candidates = document.querySelectorAll(
          '#MainContent :is(h1,h2,h3,h4,h5,h6,p,a,button,label,input,select,textarea,summary,li,dt,dd,span,strong), ' +
          '#t4s-footer :is(p,a,button,label,input,select,textarea,h3,span,strong)'
        );
        // Conservative line/control bounds also protect prices and linked images.
        obstructing = Array.from(candidates).some(element => Array.from(element.getClientRects()).some(rect =>
          rect.width > 0 && rect.height > 0 && rect.left < box.right + 4 && rect.right > box.left - 4 &&
          rect.top < box.bottom + 4 && rect.bottom > box.top - 4
        ));
      }
    }
    body.toggleAttribute('data-atease-chat-obstructing', obstructing);
  };
  const revealUtilities = () => {
    body.toggleAttribute('data-atease-utilities-hidden', false);
    lastY = scrollPosition();
    direction = 0;
    distance = 0;
    updateChatClearance();
  };
  const updateUtilities = () => {
    pending = false;
    const y = scrollPosition();
    const delta = y - lastY;
    lastY = y;
    updateChatClearance();
    if (!mobileUtilities.matches || y <= 48 || scrollLimit() - y <= 2) {
      revealUtilities();
      return;
    }
    if (!delta) return;
    const nextDirection = Math.sign(delta);
    distance = nextDirection === direction ? distance + Math.abs(delta) : Math.abs(delta);
    direction = nextDirection;
    if (distance >= 16) {
      body.toggleAttribute('data-atease-utilities-hidden', direction > 0);
      distance = 0;
    }
  };
  const scheduleUtilities = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(updateUtilities);
  };
  window.addEventListener('scroll', scheduleUtilities, { passive: true });
  window.addEventListener('resize', scheduleUtilities);
  window.addEventListener('load', scheduleUtilities);
  mobileUtilities.addEventListener('change', revealUtilities);
  window.addEventListener('pageshow', revealUtilities);
  document.addEventListener('focusin', event => {
    // Shadow-root focus retargets to Shopify's host; leave its internals untouched.
    if (event.target.closest?.('shopify-chat, #t4s-backToTop')) revealUtilities();
  });
  // React to delayed widget initialization, content reflow and the preview bar.
  if (typeof MutationObserver !== 'undefined') {
    const observedShadows = new WeakSet();
    const pendingHosts = new WeakSet();
    const observer = new MutationObserver(() => {
      observeChat();
      scheduleUtilities();
    });
    const observeChat = () => {
      chatRoots().forEach(shadow => {
        if (!observedShadows.has(shadow)) {
          observedShadows.add(shadow);
          observer.observe(shadow, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'open'] });
        }
        shadow.querySelectorAll('[exportparts]').forEach(host => {
          if (!host.shadowRoot && host.localName.includes('-') && !pendingHosts.has(host)) {
            pendingHosts.add(host);
            customElements.whenDefined(host.localName).then(() => {
              observeChat();
              scheduleUtilities();
            });
          }
        });
      });
    };
    observer.observe(body, { childList: true, subtree: true });
    observeChat();
    customElements.whenDefined('shopify-chat').then(() => {
      observeChat();
      scheduleUtilities();
    });
  }
  if (typeof ResizeObserver !== 'undefined') {
    const observer = new ResizeObserver(scheduleUtilities);
    observer.observe(body);
  }
  updateChatClearance();
})();
